import { render, staticRenderFns } from "./yzldMsg.vue?vue&type=template&id=836521de&"
import script from "./yzldMsg.vue?vue&type=script&lang=js&"
export * from "./yzldMsg.vue?vue&type=script&lang=js&"
import style0 from "./yzldMsg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports